import { UploadRow, UploadRowDetail, UploadsTableConfigOptions } from './types';

export const uploadFileTypeLabelMap: Record<string, string> = {
  DICOM: 'DICOM',
  DXA: 'DXA',
  DICOMIZED_CSV: 'DICOMIZED CSV',
  DICOMIZED_PDF: 'DICOMIZED PDF',
  HRPQCT: 'HRPQCT',
  MEDIA: 'Media',
  MISC: 'MISC',
};

export const ENABLE_REMOVE_UPLOAD = false; // currently disabling remove upload feature. Once audit logs are enabled, change this to true.

export const defaultOpts: Required<UploadsTableConfigOptions> = {
  iconColWidth: 50,
  detailIconIndentPx: 15,
  detailContentIndentClass: 'pl-2',

  headerBgClass: '',
  rowBgClass: '',
  headerBgInline: '',
  rowBgInline: '',
  headerTextClass: 'text-spanishGray font-medium',

  dataFontSizePx: 14,
  dataLineHeightPx: 30,

  actionIconSizeClass: 'text-[25px]',
  dateTextClass: 'text-black',
  timeTextClass: 'text-spanishGray',

  onDeleteGroupClick: (() => {}) as (row: UploadRow) => void,
  onViewExecutionRequest: (() => {}) as (row: UploadRowDetail) => void,
  onViewExecutionResponse: (() => {}) as (row: UploadRowDetail) => void,
};
